// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a7584c36","301":"ffb33a82"}[chunkId] + ".chunk.js";
};